import { parseManaCost } from '@mtg/shared';
import { Fragment } from 'react';

/** One mana symbol as a colored pip: {G} green, {G/W} hybrid, {2} generic. */
export function Pip({ symbol }: { symbol: string }) {
  const kind = /^[WUBRGC]$/.test(symbol) ? symbol : symbol.includes('/') ? 'hybrid' : 'generic';
  return <span className={`pip pip-${kind}`}>{symbol.replace('/P', 'ᵖ')}</span>;
}

/** A mana cost as pips, faces separated by "//". */
export function ManaCost({ cost }: { cost: string | null }) {
  const faces = parseManaCost(cost);
  if (faces.length === 0) return null;
  return (
    <span className="mana" role="img" aria-label={`Mana cost ${cost}`}>
      {faces.map((symbols, i) => (
        <Fragment key={i}>
          {i > 0 && <span className="mana-sep">//</span>}
          {symbols.map((s, j) => (
            <Pip key={j} symbol={s} />
          ))}
        </Fragment>
      ))}
    </span>
  );
}
